/* eslint-disable class-methods-use-this */
const YOUTUBE_API_CLASS = "youtube-api-script";

/**
 * Cover Video class to object and add listeners to 
 * multiple content videos
 */
export default class CoverVideo {

    /**
     * constructor for the class
     * @param {object} $element jquery element
     * @return {CoverVideo} this class
     */
    constructor($element) {
        //set up empty video player
        this.player;
        //assign key reference
        this.videoKey = `videoKey_${Date.now()}`;
        //asign eelement
        this.el = $element;
        //assign video iframe
        this.iframe = $element.find('iframe');
        //assign button trigger
        this.triggerItem = $element.find('[data-playkey]');

        //attach listeners to triggers
        this.attachListeners();

        //prepare youtube video on next cycle
        setTimeout(() => {
            //add youtube api to dom if not injected already
            if (jQuery(`#${YOUTUBE_API_CLASS}`).length === 0) {
                this.prepareYoutubeVideo();
            }
        }, 2000);
    }

    /**
     * Attach listeners
     * @return {null} nothing
     */
    attachListeners() {
        //attach triggers
        this.triggerItem.on('click', this.showVideo.bind(this));
        this.iframe.attr('id',this.videoKey);

        var _onYoutubePlayerAPI = null;
        if (window.onYouTubePlayerAPIReady) {
            _onYoutubePlayerAPI = window.onYouTubePlayerAPIReady;
        }
        // assign youtube play ready method
        window.onYouTubePlayerAPIReady = function() {
            // create the global player from the specific iframe (#video)
            this.player = new window.YT.Player(this.videoKey, {
                events: {
                    'onReady': this.onPlayerReady.bind(this),
                    'onStateChange':  this.onPlayerStateChange.bind(this)
                }
            });
            if (_onYoutubePlayerAPI) {
                _onYoutubePlayerAPI();
            }
        }.bind(this);
    }

    //on player ready set quality
    onPlayerReady(event) {
        this.player.setPlaybackQuality('hd720');
    }

    onPlayerStateChange(event) {
        if (event.data === window.YT.PlayerState.BUFFERING) {
            this.player.setPlaybackQuality('hd720');
        } else if (event.data === window.YT.PlayerState.PLAYING) {
            this.player.setPlaybackQuality('hd720');
        } else if (event.data === window.YT.PlayerState.ENDED) {
            this.hideVideo();
        }
    }

    /**
     * Show the video by adding class to container and playing player
     * @return {null} nothing
     */
    showVideo() {
        this.el.addClass('video-active');
        this.player.playVideo();
    }

    /**
     * Hide the video by removing class to container
     * @return {null} nothing
     */
    hideVideo() {
        this.el.removeClass('video-active');
    }

    /**
     * Attach the youtube api script
     * @return {null} nothing
     */
    prepareYoutubeVideo() {
        // Inject YouTube API script
        var tag = document.createElement('script');
        tag.id = YOUTUBE_API_CLASS;
        tag.src = "//www.youtube.com/player_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }


}

